export default __webpack_public_path__ + "static/media/MarkerIconRed.dc0eee70.svg";